import React from 'react';

import { Navigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { RedirectPage } from 'src/components/common';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { buildUrl } from 'src/utils/router';

export const ReportsRedirects: React.FC = () => {
  const {
    isEmployee,
    isPeoSuperAdmin,
    isPeoAdmin,
    isPeoManager,
    isEmployerAdmin,
    isEmployerManager,
    isPeoPayrollProviderUser,
    hasPlatformRoles,
    hasVerifierRoles,
  } = useCurrentUserPermissions();

  if (hasPlatformRoles) {
    return <Navigate to={buildUrl(appRoutes.reports.dataDisputes)} />;
  }

  if (hasVerifierRoles) {
    return <Navigate to={buildUrl(appRoutes.reports.verificationRequests)} />;
  }

  if (isPeoManager || isEmployerManager) {
    return <Navigate to={buildUrl(appRoutes.reports.dataDisputes)} />;
  }

  if (isPeoSuperAdmin || isPeoAdmin || isEmployerAdmin || isPeoPayrollProviderUser) {
    return <Navigate to={buildUrl(appRoutes.reports.dashboard)} />;
  }

  if (isEmployee) {
    return <Navigate to={buildUrl(appRoutes.reports.requests)} />;
  }

  return <RedirectPage />;
};
